<template>
    <section class="order-section">
        <order-header :title="valveTitle" :price="plainPrice"/>

        <div class="popup"
             v-if="valves.length > 0"
             @click="showValveSpecs = !showValveSpecs"
             :class="{'active': showValveSpecs}">
            Bekijk specs kleppen
        </div>

        <div class="dropdown-valve-specs" v-if="showValveSpecs && valves.length > 0" v-for="valve in valves">
            <span class="sub-title">{{ valve.name.nl }}</span>
            <span class="sub-sub-title" v-for="av in valve.additionalValves">{{ av.name.nl }}</span>
        </div>
    </section>
</template>

<script>
  import OrderHeader from "./items/OrderHeader";
  import OrderItem from "./items/OrderItem";
  import { mapGetters, mapState } from "vuex";
  import orderMixin from "../../../mixins/orderMixin";

  export default {
    name: "OrderValves",

    components: {
      OrderHeader,
      OrderItem
    },

    mixins: [ orderMixin ],

    watch: {
      valves(newValue) {
        if(newValue.length === 0) {
          this.showValveSpecs = false;
        }
      }
    },

    data() {
      return {
        showValveSpecs: false
      }
    },

    computed: {
      ...mapGetters({
        buildValves: 'build/valves/getValves',
      }),
      ...mapState({
        stateValveType: state => state.build.valveType
      }),

      valveTitle() {
        return this.buildValves.length + 'X aantal kleppen';
      },

      plainPrice() {
        let price = 0;

        this.valves.forEach(valve => {
          price += valve.price;

          valve.additionalValves.forEach(av => {
            price += av.price;
          })
        });

        return price;
      },

      valveType() {
        if (this.stateValveType === 1) {
          return 'Enkelwerkend'
        }

        return 'Dubbelwerkend';
      },
    },
  }
</script>
